import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import axios from 'src/app/Service/axios';
declare let $: any;

@Component({

  selector: 'app-extra-classes',

  templateUrl: './extra-classes.component.html',

  styleUrls: ['./extra-classes.component.css']

})

export class ExtraClassesComponent implements OnInit {

  lst_Result: any = [];

  lst_Search: any = [];

  lst_Student: any = [];

  lst_Search_2: any = [];

  bEditMode: boolean = false;

  mdl_Search: FormGroup = this.FormBuilder.group({

    iSystemUser: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

  })

  mdl_Request: FormGroup = this.FormBuilder.group({

    iSystemUser: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

    strTitle: new FormControl('', Validators.required),

    iMadonik_SuperClass: new FormControl(''),

    index: new FormControl(''),

  })

  mdl_Checkbox: FormGroup = this.FormBuilder.group({

    iSystemUser: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

    iMadonik_SuperClass: new FormControl(''),

    iPassenger: new FormControl(''),

    bDelete: new FormControl(''),

  })

  constructor(

    private _tooltip: NotificationService,

    private FormBuilder: FormBuilder,

    private router: Router,

    private route: ActivatedRoute,

    private gurdService: GurdServiceService,

    private _otherService: OtherService,

  ) { }

  ngOnInit(): void {

    this.getAllExtra();

  }

  async getAllExtra() {

    this._otherService.Showspinner();

    let res = JSON.parse((await axios.post(`Madonik_SuperClass_List`, this._otherService.stringNumberToNumber(this.mdl_Search.value))).data.toString());

    this._otherService.nonespinner();

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this.lst_Result = res;

    this.lst_Search = res;

  }

  filter_list(val: any) {

    this.lst_Result = this.lst_Search.filter((el: any) => {

      return el.strTitle.includes(val.value)

    });

    if (val.value.trim() == '') {

      this.lst_Result = this.lst_Search;

    }

  }

  add_Request(item: any = {}, index = -1) {

    if (item.iMadonik_SuperClass) {

      this.bEditMode = true;

      Object.keys(item).forEach((key) => {

        this.mdl_Request.get(key)?.setValue(item[key])

      })

      this.mdl_Request.patchValue({

        index: index

      })

      $("#Add_ExtraClass").modal('show');


    }

    else {

      this.bEditMode = false;

      this.mdl_Request.patchValue({

        strTitle: '',

        iMadonik_SuperClass: '',

        index: ''

      })

      $("#Add_ExtraClass").modal('show');

    }

  }

  async submit_superClass() {

    if (this.mdl_Request.invalid) return this._tooltip.showError('لطفا فرم را با دقت تکمیل کید');

    if (this.bEditMode) {

      $.confirm({

        title: `آیا از ویرایش اطلاعات اطمینان دارید ؟`,

        content: '',

        type: 'blue',

        buttons: {

          ok: {

            text: "ویرایش",

            btnClass: 'btn-primary',

            keys: ['enter'],

            action: async () => {

              this._otherService.Showspinner();

              let res = JSON.parse((await axios.post(`Madonik_SuperClass_Edit`, this._otherService.stringNumberToNumber(this.mdl_Request.value))).data.toString());

              this._otherService.nonespinner();

              if (res.iResult == 0) return this._tooltip.showError(res.strError);

              this.lst_Result[this.mdl_Request.get('index')?.value] = res[0];

              this.lst_Search[this.mdl_Request.get('index')?.value] = res[0];

              this._tooltip.showSuccess('.با موفقیت ویرایش شد');

              $("#Add_ExtraClass").modal('hide');


            }

          },

          cancel: {

            text: "لغو",

          }

        }

      });

    }

    else {

      this._otherService.Showspinner();

      let res = JSON.parse((await axios.post(`Madonik_SuperClass_Save`, this._otherService.stringNumberToNumber(this.mdl_Request.value))).data.toString());

      this._otherService.nonespinner();

      if (res.iResult == 0) return this._tooltip.showError(res.strError);

      this.lst_Result.push(res[0]);

      this._tooltip.showSuccess('.با موفقیت ثبت شد');

      $("#Add_ExtraClass").modal('hide');

    }


  }

  async remove_class(item, index: number) {

    $.confirm({

      title: `آیا از حذف کلاس اطمینان دارید ؟`,

      content: '',

      type: 'red',

      buttons: {

        ok: {

          text: "حذف",

          btnClass: 'btn-danger',

          keys: ['enter'],

          action: async () => {

            this._otherService.Showspinner();

            let res = JSON.parse((await axios.post(`Madonik_SuperClass_Delete`, this._otherService.stringNumberToNumber({ ...this.mdl_Search.value, iMadonik_SuperClass: item.iMadonik_SuperClass }))).data.toString());

            this._otherService.nonespinner();

            if (res.iResult == 0 && res.strError != '') return this._tooltip.showError(res.strError);

            this.lst_Result.splice(index, 1);

            this.lst_Search.splice(index, 1);

            this._tooltip.showSuccess('با موفقیت حذف شد');

          }

        },

        cancel: {

          text: "لغو",

        }

      }

    });

  }

  async addStudent(item) {

    this._otherService.Showspinner();

    let res = JSON.parse((await axios.post(`Madonik_SuperClassStudent_List`, this._otherService.stringNumberToNumber({ ...this.mdl_Search.value, iMadonik_SuperClass: item.iMadonik_SuperClass }))).data.toString());

    this._otherService.nonespinner();

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this.lst_Student = res;

    this.lst_Search_2 = res;

    this.mdl_Checkbox.patchValue({

      iMadonik_SuperClass: item.iMadonik_SuperClass,

    })

    $("#Add_Student").modal('show');

  }

  filter_Student(val: any) {

    this.lst_Student = this.lst_Search_2.filter((el: any) => {

      return el.strPassenger_FullName.startsWith(val.value) ||

        el.strGrade.startsWith(val.value) ||

        el?.strMobileDomain_strComment?.startsWith(val.value) ||

        el.strClassNo_strTitle.startsWith(val.value)

    });

    if (val.value.trim() == '') {

      this.lst_Student = this.lst_Search_2;

    }

  }

  async setCheckBox(value: boolean, item: any, index: number) {

    if (value === true) {

      this.lst_Student[index].bSelected = 1;

      this.mdl_Checkbox.patchValue({

        iPassenger: item.iPassenger,

        bDelete: !value,

      })

      this._otherService.Showspinner();

      let res = JSON.parse((await axios.post(`Madonik_SuperClassStudent_SaveDelete`, this._otherService.stringNumberToNumber(this.mdl_Checkbox.value))).data.toString());

      this._otherService.nonespinner();

      if (res.iResult == 0) {

        this.lst_Student[index].bSelected = 0;

        return this._tooltip.showError(res.strError);

      }

      this._tooltip.showSuccess('با موفقیت انجام شد');

    }

    else {

      this.lst_Student[index].bSelected = 0;

      this.mdl_Checkbox.patchValue({

        iPassenger: item.iPassenger,

        bDelete: !value,

      })

      this._otherService.Showspinner();

      let res = JSON.parse((await axios.post(`Madonik_SuperClassStudent_SaveDelete`, this._otherService.stringNumberToNumber(this.mdl_Checkbox.value))).data.toString());

      this._otherService.nonespinner();

      if (res.iResult == 0) {

        this.lst_Student[index].bSelected = 1;

        return this._tooltip.showError(res.strError);

      }

      this._tooltip.showSuccess('با موفقیت انجام شد');


    }

  }

  async addOrRemove_Student(bAddOrRemove: boolean) {

    const lstiPassenger = []

    if (bAddOrRemove == true) {

      for (let i = 0; i < this.lst_Student.length; i++) {

        lstiPassenger.push(this.lst_Student[i].iPassenger);

      }

      let model = {

        ...this.mdl_Checkbox.value,

        bAddOrRemove: !bAddOrRemove,

        lstiPassenger: lstiPassenger

      }

      this._otherService.Showspinner();

      let res = JSON.parse((await axios.post(`Madonik_SuperClassStudent_SaveDeleteGroup`, model)).data.toString());

      this._otherService.nonespinner();

      if (res.iResult == 0) return this._tooltip.showError(res.strError);

      this._tooltip.showSuccess('عملیات با موفقیت انجام شد');

      $("#Add_Student").modal('hide');

    }

    else {

      for (let i = 0; i < this.lst_Student.length; i++) {

        lstiPassenger.push(this.lst_Student[i].iPassenger);

      }

      let model = {

        ...this.mdl_Checkbox.value,

        bAddOrRemove: !bAddOrRemove,

        lstiPassenger: lstiPassenger

      }

      this._otherService.Showspinner();

      let res = JSON.parse((await axios.post(`Madonik_SuperClassStudent_SaveDeleteGroup`, model)).data.toString());

      this._otherService.nonespinner();

      if (res.iResult == 0) return this._tooltip.showError(res.strError);

      this._tooltip.showSuccess('عملیات با موفقیت انجام شد');

      $("#Add_Student").modal('hide');

    }

  }

  async selectAll() {

    const lstiPassenger = []

    for (let i = 0; i < this.lst_Student.length; i++) {

      lstiPassenger.push(this.lst_Student[i].iPassenger);

    }

    let model = {

      ...this.mdl_Checkbox.value,

      bAddOrRemove: false,

      lstiPassenger: lstiPassenger

    }

    this._otherService.Showspinner();

    let res = JSON.parse((await axios.post(`Madonik_SuperClassStudent_SaveDeleteGroup`, model)).data.toString());

    this._otherService.nonespinner();

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this._tooltip.showSuccess('عملیات با موفقیت انجام شد');

    $("#Add_Student").modal('hide');

  }

}
